import React from 'react';
import Footer from '../footer';
import Navigator from './navigator';
import FireKing from './fireking1';
import CanonDRF120 from './canon/drf120';
import CanonDRC225 from './canon/drc225';
import CanonDRM140 from './canon/drm140';
import Intimus60cp4 from './martinyale/intimus60cp4';
import Intimus100cp4 from './martinyale/intimus100cp4';
import Intimus120cp4 from './martinyale/intimus120cp4';
import Intimus45cc3 from './martinyale/intimus45cc3';
import Intimus32cc from './martinyale/intimus32cc';
import CanonIpf770 from './canon/ipf770';
import CanonIpf780 from './canon/ipf785';
import CanonMF264cdw from './canon/mf264cdw';
import CanonC910 from './canon/c910';
import FourZeroFour from '../fourzerofour';

const StaticRenderer = (props) => {
    return (
        <>
            {<GetDynamic name={props.match.params.page} />}
            <Footer />
        </>
    )
}

export default StaticRenderer;

const GetDynamic = (props) => {
    switch (props.name) {
        case "navigator":
            return (
                <Navigator />
            )
        case "drf120":
            return (
                <CanonDRF120 />)
        case "drc225":
            return (
                <CanonDRC225 />)
        case "drm140":
            return (
                <CanonDRM140 />)
        case "ipf785":
            return (
                <CanonIpf780 />)
        case "ipf770":
            return (
                <CanonIpf770 />)
        case "c910":
            return (
                <CanonC910 />)

        case "intimus60cp4":
            return (
                <Intimus60cp4 />
            )

        case "intimus120cp4":
            return (
                <Intimus120cp4 />
            )

        case "intimus100cp4":
            return (
                <Intimus100cp4 />
            )

        case "intimus32cc":
            return (
                <Intimus32cc />
            )

        case "intimus45cc3":
            return (
                <Intimus45cc3 />
            )

        case "mf264cdw":
            return (
                <CanonMF264cdw />
            )
        case "fireking1":
            return (
                <FireKing />
            )

        default:
            return (
                <FourZeroFour />
            )
    }
}


